<template>
  <div class="offline-meeting-detail-template" theme>
    <div id="offline-meeting-detail-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'offline-meeting',
      parts: [
        {
          elem: '#offline-meeting-detail-content',
          htmlFile: 'detail'
        }
      ]
    }
  }
}
</script>
